/* Model */
class CancelCodeModel extends App.Models.BaseModel {
    modelUrl = 'CancelCode';
}

App.Models.CancelCode = CancelCodeModel;

/* Collection */
class CancelCodeCollection extends App.Collections.BaseCollection {
    url = 'CancelCode';
    model = App.Models.CancelCode;
}

App.Collections.CancelCodes = CancelCodeCollection;

/* Router */
class CancelCodeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'CancelCode';
        const model = App.Models.CancelCode;
        const collectionClass = App.Collections.CancelCodes;

        super(entityName, model, collectionClass);
    }
}

App.Routers.CancelCode = CancelCodeRouter;
